import admin from "../../const/admin";
import netcoServer from '../../apis/netcoServer';
import {UPDATE_WEBSERVICE_USER} from "../types";
import handleResponse from '../helpers/handleResponse';
import infoPayload from "../helpers/payloadHandlers/infoPayload";
import modalDismiss from "../modal/modalDismiss";
import getBase64File from "../helpers/getBase64File";
import loadingCall from "../helpers/loadingCall";

const updateWebServiceUser= (formValues, file, callback) => async (dispatch, getState) => {
  if(file !== null)
    formValues.base64File = await getBase64File(file);
  let response = await loadingCall(dispatch, () => netcoServer.newPost('/SystemService/updateWebserviceUser', formValues));
  handleResponse(dispatch, response, UPDATE_WEBSERVICE_USER, data => onSuccessPayload(data, getState), null, [modalDismiss], [callback]);
};
const onSuccessPayload = (data, getState) => {
  return infoPayload('success', admin[getState().auth.language].authorizedIPUpdated);
};
export default updateWebServiceUser;